var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.globalMessage)?_c('div',{ref:"globalMessage",staticClass:"alert rounded-0 mb-0",class:("alert-" + (_vm.globalMessage.style)),attrs:{"role":"alert"}},[(_vm.globalMessage.type === 'MAINTAIN')?[_vm._v("\n    "+_vm._s(_vm.$t('common.maintainMessage', [
        _vm.$dayjs
          .utc(_vm.globalMessage.data.startTime)
          .tz()
          .format('HH:mm'),
        _vm.$dayjs
          .utc(_vm.globalMessage.data.endTime)
          .tz()
          .format('HH:mm')
      ]))+"\n  ")]:_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }